import React from 'react';

export const Spinner = ({ cssClass, width = 25, height = 25 }) => {
    const spinnerCssClass = `spinner ${cssClass}`;
    const style = {
        width: width,
        height: height,
    };
    return <div style={style} className={spinnerCssClass}></div>;
};
